import { render, staticRenderFns } from "./RelatedDocumentTab.vue?vue&type=template&id=4ac6ad84&"
import script from "./RelatedDocumentTab.vue?vue&type=script&lang=js&"
export * from "./RelatedDocumentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports